import { shellfishExclusion } from "./portalShellfishExclusion";
import { delLines } from "./portalDelLines";
import { dryBay } from "./portalDryBay";
import { mullicaRiver } from "./portalMullicaRiver50";

export const regLayers = {
  id: 'reg',
  type: 'group',
  title: "Regulatory Layers",
  items: [
    delLines,
    dryBay,
    mullicaRiver,
    shellfishExclusion,
  ],
};
